<div
    #systemStatus
    class="system-status-container"
    *ngIf="simulatorIsRunning(); else startSimulatorMessage"
>
    <app-ops-status-side-menu
        [isReceivingData]="systemStatusConnected"
        [systemStatusData]="systemStatusData"
        [selectedCommIF]="selectedCommIF"
        [selectedFcuSrc]="selectedFcuSrc"
        [selectedPage]="selectedPage"
        (onPageSelected)="handlePageSelected($event)"
        (onSelectCommIf)="selectedCommIF = $event"
    ></app-ops-status-side-menu>

    <app-overview
        style="width: 100%; min-height: 100%"
        *ngIf="selectedPage === overviewPage"
        [systemStatusData]="systemStatusData"
        [isReceivingData]="systemStatusConnected"
        (onPageSelected)="handlePageSelected($event)"
    >
    </app-overview>
    <app-eap-status
        style="width: 100%; min-height: 100%"
        *ngIf="selectedPage === eapPage"
        [isReceivingData]="systemStatusConnected"
        [eapArray]="systemStatusData?.eap"
    >
    </app-eap-status>
    <app-ops-status
        style="width: 100%; min-height: 100%"
        *ngIf="selectedPage === opsPage"
        [isReceivingData]="systemStatusConnected"
        [opsArray]="systemStatusData?.ops"
    >
    </app-ops-status>
    <app-fcu-status
        [hidden]="selectedPage !== fcuPage"
        style="width: 100%; min-height: 100%"
        [fcuStatusObject]="systemStatusData?.fcu"
        [isReceivingData]="systemStatusConnected"
        [selectedFcuSrc]="selectedFcuSrc"
    >
    </app-fcu-status>
    <app-comms-status
        [hidden]="selectedPage !== commsPage"
        style="width: 100%; min-height: 100%"
        [commIFArray]="systemStatusData?.comms"
        [isReceivingData]="systemStatusConnected"
        [selectedComm]="selectedCommIF"
        (onSelectCommIf)="selectedCommIF = $event"
    >
    </app-comms-status>
    <app-printers-status
        style="width: 100%; min-height: 100%"
        *ngIf="selectedPage === printersPage"
        [isReceivingData]="systemStatusConnected"
        [printerArray]="systemStatusData.printers"
    >
    </app-printers-status>
</div>

<ng-template #startSimulatorMessage>
    <div class="system-status-container">
        <div class="start-message">
            {{ "system-status.message.start-simualtor" | translate }}
        </div>
    </div>
</ng-template>
